import React, { useState } from "react";
import "./PoliticaCookies.css";
import { resetCookieConsentValue } from "react-cookie-consent";
import { getCookiesStatus } from "../../utils/cookies-management";
import { acceptCookies, declineCookies } from "../../utils/cookies-management";

function PoliticaCookies(props) {
    const [gaActive, setGaActive] = useState(getCookiesStatus());
    const [acceptClicked, setAcceptClicked] = useState(false);
    const [declineClicked, setDeclineClicked] = useState(false);
    const message = {
        success: "Cookies acceptades",
        error: "Cookies rebutjades",
        loading: "Processant...",
    };
    const [currentMessage, setCurrentMessage] = useState(
        "Estat de consentiment: " + (gaActive ? message.success : message.error)
    );

    function acceptCookiesLocal() {
        acceptCookies();
        setAcceptClicked(true);
        setDeclineClicked(false);
        setGaActive(true);
        setCurrentMessage("Estat de consentiment: " + message.success);
    }

    function declineCookiesLocal() {
        declineCookies();
        resetCookieConsentValue();
        window.location.reload();
    }

    return (
        <div className="politica-cookies-container">
            <h1>Política de cookies</h1>
            <p>
                Els nostre lloc web utilitza una tecnologia anomenada "cookie",
                amb la finalitat de poder obtenir informació sobre l'ús del lloc
                web, millorar l’experiència de l’usuari i garantir el seu
                correcte funcionament.
            </p>
            <br />
            <h2>Definició de Cookie</h2>
            <p>
                Una “cookie” és un petit fragment de text que els llocs web
                envien al navegador i que s'emmagatzemen en el terminal de
                l'usuari, (ordinador o dispositiu mòbil). Aquests arxius tenen
                la finalitat d'emmagatzemar dades que podran ser actualitzades i
                recuperades per l'entitat responsable de la seva instal·lació.
                Així, cada vegada que l'usuari torna a visitar el mateix lloc
                web, l'explorador recupera l'arxiu i l'envia al servidor del
                lloc web. Les cookies tenen diverses funcions entre les que
                s'inclouen, la de recollir informació sobre les preferències de
                l'usuari i recordar-la, i en general, facilitar l'ús del lloc
                web a l'usuari fent que el lloc sigui més útil al personalitzar
                el seu contingut
            </p>
            <br />
            <p>
                Les cookies es poden classificar en base a diferents paràmetres:
            </p>
            <br />
            <p>
                <strong>1.- Titularitat:</strong>{" "}
                <u> cookies pròpies i cookies de tercers:</u> depenent de quina
                sigui l'entitat que gestioni el domini des d'on s'envien les
                cookies i es tractin les dades que s'obtinguin.
            </p>
            <br />
            <p>
                <strong>2.- Duració:</strong>{" "}
                <u> cookies de sessió i cookies persistents:</u> d'acord amb el
                termini de temps que romanen emmagatzemades al terminal de
                l'usuari.
            </p>
            <br />
            <p>
                <strong>3.- Finalitat:</strong>{" "}
                <u>
                    {" "}
                    cookies tècniques, cookies de preferències o
                    personalització, cookies d'anàlisi o mesura i cookies de
                    publicitat comportamental:{" "}
                </u>{" "}
                d'acord amb la finalitat per a la qual es tractin les dades
                obtingudes.
            </p>
            <br />
            <br />
            <li>
                <u>Cookies tècniques:</u> Són aquelles que permeten a l'usuari
                la navegació a través de la pàgina web o aplicació i la
                utilització de les diferents opcions o serveis que en ella
                existeixen. Per exemple, controlar el trànsit i la comunicació
                de dades , identificar la sessió o accedir a les parts web
                d'accés restringit.
            </li>
            <br />
            <li>
                <u>Cookies de preferències o personalització</u> Són aquelles
                que permeten recordar informació perquè l'usuari accedeixi al
                servei amb determinades característiques que poden diferenciar
                la seva experiència de la d'altres usuaris, com, per exemple,
                l'idioma, el número de resultats a mostrar quan l'usuari
                realitza una cerca, l'aspecte o contingut del servei en funció
                del tipus de navegador a través del qual l'usuari accedeix al
                servei o de la regió des de la qual accedeix al servei, etc.{" "}
            </li>
            <br />
            <li>
                <u>Cookies d'anàlisi o mesura:</u> Són aquelles que permeten al
                seu responsable el seguiment i l'anàlisi del comportament dels
                usuaris dels llocs web als quals estan vinculades, inclosa la
                quantificació dels impactes dels anuncis. La informació
                recollida mitjançant aquest tipus de cookies s'utilitza en el
                mesurament de l'activitat dels llocs web, aplicació o
                plataforma, per tal d'introduir millores en funció de l'anàlisi
                de les dades d'ús que fan els usuaris del servei.
            </li>
            <br />
            <li>
                <u>Cookies de publicitat comportamental:</u> Són aquelles que
                emmagatzemen informació del comportament dels usuaris obtinguda
                a través de l'observació continuada dels seus hàbits de
                navegació, cosa que permet desenvolupar un perfil específic per
                mostrar publicitat en funció d’aquest perfil.
            </li>
            <br />
            <br />
            <h2>Cookies utilitzades al nostre lloc web</h2>
            <p>
                El nostre lloc web utilitza tant cookies pròpies, que són les
                enviades al seu ordinador i gestionades exclusivament per
                nosaltres per al millor funcionament del lloc web, com cookies
                de tercers, amb la funció de servir per a la interacció dels
                usuaris amb nosaltres.
            </p>
            <br />
            <p>
                El nostre lloc web fa servir tant cookies temporals de sessió
                com cookies persistents. Les cookies de sessió emmagatzemen
                dades únicament mentre l'usuari accedeix a la web i les cookies
                persistents emmagatzemen les dades en el terminal perquè siguin
                accedides i utilitzades en més d'una sessió.
            </p>
            <br />
            <p>
                Concretament, les cookies que precisen de consentiment
                utilitzades al nostre lloc web són:
            </p>
            <br />
            <table>
                <thead>
                    <th>Nom</th>
                    <th>Titular</th>
                    <th>Finalitat</th>
                    <th>Durada</th>
                </thead>
                <tbody style={{ fontSize: "13px" }}>
                    <tr>
                        <td>
                            <p>_ga</p>
                            <p>_ga_xxxxxxxxx</p>
                        </td>
                        <td>
                            <a href="">immobiliariaripollesassessors.cat</a>
                        </td>
                        <td>
                            <strong style={{ marginBottom: "10px" }}>
                                Analítica:
                            </strong>

                            <li>
                                Instal·lada per Google Analytics, calcula les
                                dades de visitants, sessions i campanyes i també
                                realitza un seguiment de l'ús del lloc per a
                                l'informe analític del lloc. La cookie
                                emmagatzema informació de forma anònima i
                                assigna un nombre generat aleatòriament per
                                reconèixer visitants únics.
                            </li>

                            <br />
                        </td>
                        <td>
                            <p>1 any i 35 dies</p>
                        </td>
                    </tr>
                </tbody>
            </table>
            <p style={{ fontSize: "13px" }}>
                Per obtenir més informació sobre les cookies d'aquest tercer pot
                clicar a{" "}
                <span style={{ fontSize: "12px" }}>
                    {" "}
                    <a
                        href="https://developers.google.com/analytics/legacy/universal-analytics?hl=es"
                        target={"_blank"}
                    >
                        Google Analytics:
                    </a>{" "}
                    <a
                        href="https://policies.google.com/technologies/cookies?hl=es&gl=es#types-of-cookies"
                        target={"_blank"}
                    >
                        Google LLC
                    </a>
                </span>
            </p>
            <br />
            Finalment, també s'utilitzen cookies de complement (plug-in) per
            intercanviar continguts socials.
            <br />
            <br />
            <br />
            <h2>Consentiment</h2>
            <br />
            <p>
                El consentiment per a l'ús de les cookies abans enunciades, pels
                terminis assenyalats i en les condicions contingudes en la
                present Política de Cookies, s’obtindrà amb l’acceptació de
                l’avís inicial d’informació sobre les cookies que es visualitza
                en el moment en que carrega la nostra web.
            </p>
            <br />
            <p>
                L'ús de cookies analítiques de Google (incloses les cookies de
                youtube) implica una transmissió de dades a aquestes companyies
                ubicades als Estats Units d'Amèrica. Els Estats Units i la Unió
                Europea tenen un acord Marc de Privadesa aprovat per la Decisió
                d'Execució de la Comissió de 10.7.2023 d'acord amb el Reglament
                (UE) 2016/679 del Parlament Europeu i del Consell. Pot trobar
                més informació en la política de privacitat de{" "}
                <a
                    href="https://policies.google.com/privacy?hl=es&gl=es"
                    target={"_blank"}
                >
                    Google
                </a>
                .
            </p>
            <br />
            <br />
            <h2>Gestió manual del consentiment de cookies</h2>
            <br />
            <p>
                En aquest apartat l'usuari podrà modificar manualment el seu
                consentiment/desistiment de l'ús de cookies.
            </p>
            {/* <p className="gestion-cookies-subtitle">
                Quan acceptis/declinis el consentiment de cookies, és possible
                que es refresqui la pàgina per a aplicar els canvis.
            </p> */}
            <br />
            <div className="gestion-cookies-container">
                <button
                    onClick={() => {
                        acceptCookiesLocal();
                    }}
                >
                    Acceptar cookies
                </button>
                <button
                    onClick={() => {
                        declineCookiesLocal();
                    }}
                >
                    Rebutjar cookies
                </button>
            </div>
            {gaActive ? (
                <p className="gestion-cookies-message">{currentMessage}</p>
            ) : (
                <p className="gestion-cookies-message cookie-declined">
                    {currentMessage}
                </p>
            )}
            <br />
            <br />
            <h2>Com desactivar les cookies en els principals navegadors?</h2>
            <br />
            <p>
                Tot i que pot variar lleugerament d'una versió de navegador a
                una altra, la configuració de la política de cookies per als
                navegadors més utilitzats és la següent:
            </p>
            <br />
            <li>
                {" "}
                <a
                    href="https://support.microsoft.com/es-es/microsoft-edge/microsoft-edge-datos-de-exploraci%C3%B3n-y-privacidad-bb8174ba-9d73-dcf2-9b4a-c582b4e640dd"
                    target="_blank"
                >
                    Edge
                </a>
            </li>
            <li>
                <a
                    href="https://support.mozilla.org/es/kb/Borrar%20cookies"
                    target="_blank"
                >
                    Firefox
                </a>
            </li>
            <li>
                <a
                    href="https://support.google.com/chrome/answer/95647?hl=es"
                    target="_blank"
                >
                    Chrome
                </a>
            </li>
            <li>
                {" "}
                <a
                    href="https://support.apple.com/es-es/guide/safari/manage-cookies-and-website-data-sfri11471/mac"
                    target="_blank"
                >
                    Safari (mac)
                </a>
            </li>
            <li>
                <a
                    href="https://support.apple.com/es-es/HT201265"
                    target="_blank"
                >
                    Safari (iPhone/iPad)
                </a>
            </li>
            <li>
                {" "}
                <a
                    href="https://help.opera.com/en/latest/web-preferences/#cookies"
                    target="_blank"
                >
                    Opera
                </a>
            </li>
            <br />
            <p>
                A més, també pot gestionar el magatzem de cookies al seu
                navegador a través d'eines com les següents:
            </p>
            <li>
                {" "}
                <a
                    href="https://www.youronlinechoices.com/es/"
                    target={"_blank"}
                >
                    Your online choices
                </a>
                <li>
                    {" "}
                    <a href="https://www.ghostery.com/" target={"_blank"}>
                        Ghostery
                    </a>
                </li>
                <br />
                <h2>Actualització de la política de cookies</h2>
                <br />
                <p>
                    Aquest lloc web pot modificar aquesta Política sobre
                    Cookies, per això li recomanem revisar aquesta política cada
                    vegada que accedeixi al nostre lloc web per estar
                    adequadament informat sobre l'ús que fem de les cookies.{" "}
                </p>
                <br />
                <p> Data de l’última actualització: juliol 2025</p>
                <br />
            </li>
        </div>
    );
}

export default PoliticaCookies;
